import { KYMW0800Model } from './../kymw0800.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 実績履歴出力クラス
 *
 * @export MakeResultListService
 * @class MakeResultListService
 * @extends {PlessResponder}
 */
@Injectable()
export class MakeResultListService extends PlessJsonResponderSub<any> {
  // 処理に使用するModel
  private model: KYMW0800Model;
  private vo: any;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof MakeResultListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        DetailFlg: this.vo.detailFlg,
        SessionId: this.vo.sessionId
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof MakeResultListService
   */
  execute(model: KYMW0800Model, vo: any, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('KYMW0800MakeResultList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof MakeResultListService
   */
  success(data: any): void {
    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
